import { Component, OnInit, Inject, ɵCompiler_compileModuleSync__POST_R3__} from '@angular/core';
import { AngularFireDatabase } from '@angular/fire/database';
import { AngularFirestore, AngularFirestoreCollection, AngularFirestoreDocument } from '@angular/fire/firestore';
import {MAT_BOTTOM_SHEET_DATA, MatBottomSheetRef} from '@angular/material/bottom-sheet';
import { ChurchApplication } from 'src/app/Models/applications.interface';
import { ConversationMeta } from 'src/app/Models/conversation.interface';
import { EmailNotification, ForwardNotification } from 'src/app/Models/Notify.interface';
import { Profile } from 'src/app/Models/profile.interface';
import { FORWARD, NOTIFY, PROFILES } from 'src/Constants';

@Component({
  selector: 'app-message-sheet',
  templateUrl: './message-sheet.component.html',
  styleUrls: ['./message-sheet.component.css']
})
export class MessageSheetComponent implements OnInit {

  constructor(
    private afs: AngularFirestore,
    private db: AngularFireDatabase,
    @Inject(MAT_BOTTOM_SHEET_DATA) public data: {
      conversation: ConversationMeta
      conversationRef: AngularFirestoreDocument,
      instructor: Profile,
      orgId: String
    },
    private _bottomSheetRef: MatBottomSheetRef<MessageSheetComponent>,
    ) {
    }

  ngOnInit(): void {
  }

  markResolved(event: MouseEvent): void {
    this._bottomSheetRef.dismiss();
    event.preventDefault();
    this.data.conversationRef.update({resolved: true})
  }
  markUnresolved(event: MouseEvent): void {
    this._bottomSheetRef.dismiss();
    event.preventDefault();
    this.data.conversationRef.update({resolved: false})
  }

  deleteConversation(event: MouseEvent): void {
    this._bottomSheetRef.dismiss();
    event.preventDefault();
  }

  archive(event: MouseEvent): void {
    this._bottomSheetRef.dismiss();
    event.preventDefault();
    this.data.conversationRef.update({archived: true})
  }

  async notify(event: MouseEvent){
    // only applicable if you are an instructor.
      this._bottomSheetRef.dismiss();
      event.preventDefault();
      try{
        let {firstname: name, email, preferences} = await this.afs.doc<Profile>(`${PROFILES}/${this.data.conversation.creator}`)    
          .valueChanges()
          .take(1)
          .toPromise()

        if(!preferences?.notifications?.emailsEnabled){
            alert("User has disabled Email notifications")
            return;
        }

        let notification = {} as EmailNotification
        notification.instructor = this.data.instructor.firstname // instructors first name
        notification.name = name // users first name
        notification.to = email // users email
        notification.last = new Date().getTime()
        this.db.object(`${NOTIFY}/${this.data.conversation.creator}`).update(notification)
      } catch(e) {
        console.error(e)
      }
  
    }

    async forward(event: MouseEvent) {
      // only applicable if you are an instructor.
        this._bottomSheetRef.dismiss();
        event.preventDefault();
        try{
          let name = this.data.conversation.originalCreator.firstname
          let org =  await this.afs.doc<ChurchApplication>(`/Organizations/${this.data.orgId}`)    
            .valueChanges()
            .take(1)
            .toPromise()

          

          let to = org?.pastor?.email
          let cc = this.data.instructor.email
          let notification = {} as ForwardNotification
          notification.instructor = this.data.instructor.firstname // instructors first name
          notification.name = name // users first name
          notification.to = to
          notification.cc = cc
          notification.last = new Date().getTime()
          notification.message = this.data.conversation.originalQuestion || ""
          this.db.object(`${FORWARD}/${this.data.conversation.creator}`).update(notification)
          this.data.conversationRef.update({forwarded: true})
        } catch(e) {
          console.error(e)
        }
    }
  

}
